import FlexThumb from "../images/FlexThumb";

const ThumbScroller = (props) => {
    const { data, selected, section } = props;
    return(
        <div className="thumb_scroller">
            { data.map((obj) => {
                const issel = obj.slug === selected
                obj.selected = issel;
                obj.section = section;
                return (
                    <FlexThumb {...obj} key={obj.name} />
                )
            })}
        </div>
    )
}

export default ThumbScroller;